import React from 'react';
import './RightHeader.scss';

export function RightHeader({ title }: { title: string }): JSX.Element {
  return <h4 className="right-header">{title}</h4>;
}
